/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import {makeStyles} from '@material-ui/core/styles';
import {IonSpinner} from '@ion/dls/src/components/loading/IonSpinner';
import theme, {dlsColor} from '@ion/dls/src/theme/theme';

export interface BackdropComponentProps {
  open: boolean
};

const useStyles = makeStyles(theme => ({
  backdrop : {
    zIndex : 998,
    color  : dlsColor('caBlue')
  }
}));

/**
 * @BackdropComponent
 *
 * Abstracted Backdrop and Circular Progress that allow for displaying
 * that somethings is not loading complete
 *
 * ```typescript
 * import {BackdropComponent} from '@ion/dls/src/components/BackdropComponent';
 *
 * <BackdropComponent open={show} />
 *
 * ```
 *
 * @param {boolean} open: visibility of the component
 */

export const BackdropComponent = ({open = false}: BackdropComponentProps) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={open}>
      <IonSpinner />
    </Backdrop>
  );
};
  
export default memo(BackdropComponent);
